import PoolResult from '../components/Lottery/PoolResult';

const LotteryResultDetailPage = () => {
	return <PoolResult />;
};

export default LotteryResultDetailPage;
